import { useRouteAnalytics } from 'hooks/useRouteAnalytics';
var RouteAnalyticsWrapper = function (_a) {
    var children = _a.children, aaData = _a.aaData;
    useRouteAnalytics(aaData);
    return children;
};
export default RouteAnalyticsWrapper;
